import React from "react";
import { ChevronRight } from "lucide-react";
import { formatINR, formatNum, formatPct } from "@/lib/api";

const formatters = {
  inr: formatINR,
  num: formatNum,
  pct: formatPct,
};

export const KpiTile = ({ label, value, format = "num", glyph, hint, variant, testId, onClick }) => {
  const fmt = formatters[format] || formatNum;
  const variantClass = variant ? variant : "";
  const clickableClass = onClick ? "kpi-clickable" : "";
  const cls = `kpi-tile rise ${variantClass} ${clickableClass}`.trim();
  const Tag = onClick ? "button" : "div";
  const interactiveProps = onClick
    ? { type: "button", onClick }
    : {};
  return (
    <Tag className={cls} data-testid={testId} {...interactiveProps}>
      <span className="glyph">{glyph}</span>
      {onClick && (
        <span
          className="absolute top-2 right-2 inline-flex items-center justify-center w-5 h-5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity bg-foreground/5"
          aria-hidden="true"
        >
          <ChevronRight className="w-3 h-3" />
        </span>
      )}
      <div className="text-[11px] uppercase tracking-[0.14em] font-semibold opacity-70">
        {label}
      </div>
      <div className="mt-2 font-display text-3xl sm:text-4xl font-semibold tabular">
        {fmt(value)}
      </div>
      {hint && (
        <div className="mt-1 text-xs opacity-70 tabular">{hint}</div>
      )}
    </Tag>
  );
};
